export const TRAILER_ERROR =
  "Trailer must be a video file or a Vimeo/YouTube link";

export const TRAILER_VIDEO_EXTENSIONS = [".mp4", ".webm", ".mov", ".ogv"];

export const TRAILER_ACCEPT = {
  "video/mp4": [".mp4"],
  "video/webm": [".webm"],
  "video/quicktime": [".mov"],
  "video/ogg": [".ogv"],
};

const TRAILER_MIME_TYPES = Object.keys(TRAILER_ACCEPT);

const VIMEO_REGEX = /^(https?:\/\/)?(www\.|player\.)?vimeo\.com\/(video\/)?\d+/i;
const YOUTUBE_REGEX =
  /^(https?:\/\/)?(www\.|m\.)?(youtube\.com\/(watch\?|embed\/|shorts\/)|youtu\.be\/)[\w\-?=&%./]+/i;

const getExtension = (url) => {
  const match = String(url).match(/\.([0-9a-zA-Z]+)(?:[?#]|$)/);
  return match ? `.${match[1].toLowerCase()}` : "";
};

export const isVimeoOrYoutubeUrl = (url) =>
  typeof url === "string" && (VIMEO_REGEX.test(url) || YOUTUBE_REGEX.test(url));

export const isTrailerVideoFile = (file) => {
  if (!file || typeof file === "string") return false;
  const name = (file.name || "").toLowerCase();
  const hasExt = TRAILER_VIDEO_EXTENSIONS.some((ext) => name.endsWith(ext));
  return TRAILER_MIME_TYPES.includes(file.type) && hasExt;
};

// Empty is valid. Strings must be a Vimeo/YouTube link or a direct video URL.
export const isValidTrailerUrl = (url) => {
  if (!url) return true;
  if (typeof url !== "string") return false;
  if (isVimeoOrYoutubeUrl(url)) return true;
  return TRAILER_VIDEO_EXTENSIONS.includes(getExtension(url));
};

export const isValidTrailerValue = (value) => {
  if (!value) return true;
  if (typeof value === "string") return isValidTrailerUrl(value);
  if (value.url && !value.type) return isValidTrailerUrl(value.url);
  return isTrailerVideoFile(value);
};
